import { Organization } from "lib/api/types";

// TODO: move into utils/time.ts
export const numberOfDaysLeftInTrial = (org: Organization): number => {
  return Math.ceil(
    (new Date(org.trialExpiresAt).getTime() - Date.now()) / 86400000
  );
};
